import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { VippsService } from 'src/app/services/vipps.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginView implements OnInit {

  constructor(
    private router: Router,
    private api: ApiService,
    private vipps: VippsService
  ) {
  }

  ngOnInit(): void {
    
  }

  vippsAuthorize(){
    this.vipps.authorize()
  }

  formAuthorize(){
    this.router.navigate(['form'])
  }

}
